import { useEffect, useRef, useState } from 'react';
import { produce } from 'immer';

export const useToggle = () => {
  const [toggles, setToggles] = useState([]); // 토글 상태 관리
  const refs = useRef([]);

  // 토글 각 버튼 highlight 처리
  const handleToggle = (target) => {
    const isHighlight = target.classList.toggle('highlight');
    const prev = target.previousElementSibling;
    const next = target.nextElementSibling;
    if (prev) prev.classList.remove('highlight');
    if (next) next.classList.remove('highlight');

    return isHighlight;
  };

  // 모든 토글 상태 설정
  const setAllToggle = (on) => {
    setToggles((cur) =>
      produce(cur, (draft) => {
        draft.fill(on);
      }),
    );
  };

  // 토글 버튼 초기화
  useEffect(() => {
    const selectItems = document.querySelectorAll('[data-type="toggle"]');
    if (selectItems && selectItems.length > 0) {
      setToggles(new Array(selectItems.length).fill(null));
      refs.current = selectItems;
    }
  }, []);

  // 토글 버튼 처리
  useEffect(() => {
    if (refs.current.length === 0) return;

    refs.current.forEach((item, idx) => {
      // 1. 기존 highlight 제거
      if (item.querySelector('.highlight')) item.querySelector('.highlight').classList.toggle('highlight');

      // 2. Y / N / null 분류
      const yn = toggles[idx] ? 'Y' : toggles[idx] === null ? '' : 'N';

      item.dataset.status = yn;

      // null case
      if (yn === '') {
        // 에러상태로 초기화
        item.dataset.value = '';
        item.dataset.error = 'Y';
        item.classList.add('box-btn-area-error');
      } else {
        // Y/N case
        // 선택한 버튼 값 반영, 에러 제거
        const selected = item.querySelector(`[data-status="${yn}"]`);
        if (selected) {
          item.dataset.value = selected.dataset.value;
          item.classList.remove('box-btn-area-error');
          item.dataset.error = 'N';
          selected.classList.toggle('highlight');
        }
      }
    });
  }, [toggles]);

  return { toggles, setToggles, setAllToggle, handleToggle };
};
